import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./card.scss";

const Card = ({
  children,
  className,
  onClick,
  href,
  target,
  backgroundColor,
  icon,
  iconSize,
  center,
  ...props
}) => {
  const classes = classNames(
    "card",
    {
      [`u-bg-${backgroundColor} u-white`]: backgroundColor === "red" || backgroundColor === "black",
      "u-bg-grey-5": backgroundColor === "grey",
      "card--with-icon": !!icon,
      "card--with-medium-icon": icon && iconSize === "medium",
      "card--with-large-icon": icon && iconSize === "large",
      "card--with-xlarge-icon": icon && iconSize === "xlarge",
      "card--is-button": !!onClick,
      "u-text-center": center,
    },
    className
  );

  const handleKeyPress = e => {
    if (e.keyCode === 13) {
      onClick();
    }
  };

  let innerProps = {};

  if (onClick) {
    innerProps = {
      ...innerProps,
      onClick,
      onKeyDown: handleKeyPress,
      role: "button",
      tabIndex: "0",
    };
  }

  if (onClick || href) {
    return (
      <a href={href} target={target} className={classes} {...innerProps} {...props}>
        <div className="card__inner">
          {icon && icon({ className: "card__icon" })}
          <div className="card__inner-content">{children}</div>
        </div>
      </a>
    );
  }

  return (
    <div className={classes} {...innerProps} {...props}>
      <div className="card__inner">
        {icon && icon({ className: "card__icon" })}
        <div className="card__inner-content">{children}</div>
      </div>
    </div>
  );
};

Card.propTypes = {
  backgroundColor: PropTypes.oneOf(["white", "red", "black", "grey"]),
  icon: PropTypes.func,
  iconSize: PropTypes.oneOf(["default", "medium", "large", "xlarge"]),
  center: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.node)]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.string,
};
export default Card;
